module.exports = __webpack_public_path__ + "img/xiangmu (1).2a215ac7.png";